import React from "react";
import * as Yup from "yup";
import swal from "sweetalert";
import "./Modal.scss";
import { Formik, Form, Field } from "formik";
import submitLead from "../../utils/submitLead";
import { getUTMData } from "../../utils/tracking";

const Modal = (props) => {
  // Validación con Yup
  const SignupSchema = Yup.object().shape({
    name: Yup.string().min(2, "Mínimo 2 caracteres").max(100, "Máximo 100 caracteres").required("Campo requerido"),
    phone: Yup.string().matches(/^[0-9]{10}$/, "Debe tener 10 dígitos").required("Campo requerido"),
    email: Yup.string().email("Correo electrónico inválido").required("Campo requerido"),
    contactTime: Yup.string().min(2, "Mínimo 2 caracteres").max(50, "Máximo 50 caracteres").required("Campo requerido"),
  });

  const descargarBrochure = () => {
    const link = document.createElement("a");
    link.href = "/assets/Home/PuntaVela-Brochure.pdf";
    link.target = "_blank";
    link.download = "Brochure.pdf";
    link.click();
  };

  const mostrarExito = async (resetForm) => {
    await swal("Enviado", "Los datos han sido enviados correctamente", "success");
    resetForm();
    descargarBrochure();
  };

  return (
    <div className="contenedor_modal">
      <p onClick={() => props.setModal(false)} className="closed">X</p>
      <div className="contenedor_modal_form">
        <img src="/assets/Home/iconos-logos/img_logo_puntavela.svg" alt="" />
        <h2>¿DESEAS MÁS INFORMACIÓN?</h2>
        <p>
          Completa tus datos y, en breve, uno de nuestros asesores te contactará
          para brindarte más detalles sobre nuestras residencias.
        </p>

        <Formik
          initialValues={{
            name: "",
            phone: "",
            email: "",
            contactTime: "",
            website: "",
          }}
          validationSchema={SignupSchema}
          onSubmit={async (values, { resetForm }) => {
            // Honeypot: si un bot llenó el campo oculto, simulamos éxito sin enviar
            if (values.website) {
              await mostrarExito(resetForm);
              return;
            }

            const payload = {
              name: values.name,
              phone: values.phone,
              email: values.email,
              contactTime: values.contactTime,
              origen: "puntavela",
              ...getUTMData(),
              website: values.website,
            };

            const { ok, data } = await submitLead(payload);

            if (ok) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({ event: "lead_submit_success", origen: "puntavela" });
              await mostrarExito(resetForm);
            } else {
              console.error("Error en la solicitud:", data);
              swal("Error", "Hubo un problema al enviar el formulario.", "error");
            }
          }}
        >
          {({ errors, touched, handleSubmit, isSubmitting }) => (
            <Form onSubmit={handleSubmit}>
              <Field name="name" placeholder="Nombre" />
              {errors.name && touched.name && <div className="error">{errors.name}</div>}

              <Field name="phone" type="text" placeholder="Teléfono" />
              {errors.phone && touched.phone && <div className="error">{errors.phone}</div>}

              <Field name="email" type="email" placeholder="Correo electrónico" />
              {errors.email && touched.email && <div className="error">{errors.email}</div>}

              <Field name="contactTime" placeholder="Horario de contacto preferido" />
              {errors.contactTime && touched.contactTime && <div className="error">{errors.contactTime}</div>}

              <Field
                name="website"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                style={{ position: "absolute", left: "-9999px" }}
              />

              <p>Al enviar acepta nuestra <a onClick={() => props.setModalAviso(true)}>Política de privacidad</a></p>
              <button className="button_send" type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Enviando..." : "Enviar"}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default Modal;
